module.exports = __webpack_public_path__ + "2f6e6bbef93bac7e247482d9e74d7196.webp";